import { ProductType } from "../../helpers/enums/productType";

export function extractServices<T>(productTypes: ProductType[], services: Map<ProductType, T>) {
  return productTypes.flatMap((key) => {
    const value = services.get(key);
    return value !== undefined ? [{ key, value }] : [];
  });
}
